import { FormInput } from "components";
import { ERROR_MESSAGE } from "constants/global";

const LastName = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.last_name || ""}
    register={register("last_name", {
      required: ERROR_MESSAGE.LAST_NAME,
      validate: (value) => !!value.trim() || ERROR_MESSAGE.LAST_NAME,
    })}
    error={errors?.last_name?.message}
    placeholder="姓"
  />
);

const FirstName = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.first_name || ""}
    register={register("first_name", {
      required: ERROR_MESSAGE.FIRST_NAME,
      validate: (value) => !!value.trim() || ERROR_MESSAGE.FIRST_NAME,
    })}
    error={errors?.first_name?.message}
    placeholder="名"
  />
);

const LastNameKana = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.last_name_kana || ""}
    register={register("last_name_kana", {
      required: ERROR_MESSAGE.LAST_NAME_PARTNER_KANA,
      validate: (value) => !!value.trim() || ERROR_MESSAGE.LAST_NAME_PARTNER_KANA,
    })}
    error={errors?.last_name_kana?.message}
    placeholder="性（セイ）"
  />
);

const FirstNameKana = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.first_name_kana || ""}
    register={register("first_name_kana", {
      required: ERROR_MESSAGE.FIRST_NAME_PARTNER_KANA,
      validate: (value) => !!value.trim() || ERROR_MESSAGE.FIRST_NAME_PARTNER_KANA,
    })}
    error={errors?.first_name_kana?.message}
    placeholder="名（メイ）"
  />
);

const Email = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.email || ""}
    register={register("email")}
  />
);

const Age = ({ partnerInfo, register, errors, errorAge, clearError }) => (
  <FormInput
    defaultValue={partnerInfo?.age || ""}
    register={register("age", {
      required: ERROR_MESSAGE.AGE,
      onChange: () => clearError(),
      pattern: {
        value: /^([0-9]{0,3})$/,
        message: ERROR_MESSAGE.AGE,
      },
    })}
    type="tel"
    onlyNumber={true}
    maxlength={3}
    border={errors?.age?.message || errorAge}
  />
);

const Phone = ({ partnerInfo, register, errors }) => (
  <FormInput
    defaultValue={partnerInfo?.phone || ""}
    register={register("phone", {
      required: ERROR_MESSAGE.PHONE.REQUIRED,
      pattern: {
        value: /^([0-9]{10}|[0-9]{11})$/,
        message: ERROR_MESSAGE.PHONE.INVALID,
      },
    })}
    type="tel"
    onlyNumber={true}
    maxlength={11}
    error={errors?.phone?.message}
  />
);

const GenderAdd = ({ register, value, id, label, errors }) => (
  <div className="box-gender">
    <input
      {...register("gender", {
        required: ERROR_MESSAGE.GENDER,
      })}
      type="radio"
      name="gender"
      value={value}
      className="check-gender"
      id={"gender" + id}
    />
    <label
      className={`lblradio ${errors?.gender ? "is-invalid" : ""}`}
      htmlFor={"gender" + id}
    >
      {label}
    </label>
  </div>
);

const Gender = ({ register, value, partnerInfo, id, label, errors }) => (
  <div className="box-gender">
    <input
      {...register("gender", {
        required: ERROR_MESSAGE.GENDER,
      })}
      type="radio"
      name="gender"
      value={value}
      defaultChecked={partnerInfo?.gender == value ? true : false}
      className="check-gender"
      id={id}
    />
    <label
      className={`lblradio ${errors?.gender ? "is-invalid" : ""}`}
      htmlFor={id}
    >
      {label}
    </label>
  </div>
);

export { FirstName, LastName, Age, Phone, GenderAdd, Gender, FirstNameKana, LastNameKana, Email };
